import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { Users } from 'src/app/models/interfaces/users';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { Visitors } from '../../../interfaces/visitors';
import { Helps } from 'src/app/libs/helps';

@Component({
  selector: 'app-list-visitor',
  templateUrl: './list-visitor.component.html',
  styleUrls: ['./list-visitor.component.css']
})
export class ListVisitorComponent implements OnInit, OnChanges {

  error: any;
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private toast: ToastrService,
    private router: Router,
    private helps:Helps
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    localStorage.removeItem('endPoint');
    localStorage.setItem('endPoint',"3");
    if(changes['storesId'].currentValue!=this.storesId){
      localStorage.removeItem('stores_id');
      localStorage.setItem('stores_id',this.storesId.toString());
      this.get();
    }
  }
  view: number = 1;
  status: any;
  selected?: Visitors;
  level:number;
  ngOnInit(): void {
    this.level=this.helps.getToken()?.level;
    localStorage.removeItem('endPoint');
    localStorage.setItem('endPoint',"3");
    localStorage.removeItem('stores_id');
    localStorage.setItem('stores_id',this.storesId.toString());
    this.get();
  }
  @Input()
  storesId: number;

  items: Visitors[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  brands: any;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    start: new UntypedFormControl(),
    end: new UntypedFormControl(),
    facility_id: new UntypedFormControl(0),
    stores_id: new UntypedFormControl(0),
    q:new UntypedFormControl(''),
    state_id: new UntypedFormControl('')
  });
  secondForm = new UntypedFormGroup({
    id: new UntypedFormControl(),
  });
  delete() {
    this.secondForm.get('id')?.setValue(this.selected?.id);
    this.api.deleteVisitors(this.secondForm).subscribe(
      (res) => {
        this.toast.success('Usuario eliminado correctamente', 'VISITANTES');
        this.get();
        this.modal.dismissAll();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.msg,{enableHtml:true,closeButton:true});
      }
    );
  }
  get() {
    this.api.paginateVisitors(this.page,this.form,this.storesId).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as Visitors[];
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;

        this.totalPage = data.total;
      },
      (error) => {
        this.items = null;
        this.page = 1;
        this.collectionSize = 0;
        this.totalPage = 0;
        this.toast;
      }
    );
  }
  openModal(md:any, size: string = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
  openDelete(item: any, md: any) {
    this.selected = item;
    this.modal.open(md, {
      size: 'md',
    });
  }
  openEdit(item: any, md: any) {
    this.selected = item;
    this.modal.open(md, {
      size: 'md',
    });
  }
  search(q:string='') {
    if(q.length>=2){
      this.form.get('q').setValue(q);
      console.log('result q:',q);
      this.page=1;
    }
    this.get();
  }

  filterChange() {
    this.page = 1;
    this.get();
  }

  clean(){
    this.form.get('q').setValue('');
    this.form.get('start').setValue('');
    this.form.get('end').setValue('');
    this.form.get('state_id').setValue('');
    this.page=1;
    this.get();
  }
}

